import { Div, Spacer, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import styles from './supplementalInfo.module.scss'

const SupplementalInfo: React.FC = () => {
  return (
    <Div className={styles.main}>
      <Spacer space="x3" />
      <Text type="footnote">
        * Monthly subscription points expire after 12 months if unused. However,
        if a purchase has been made on the account within 12 months of when the
        points are set to expire, the points will remain in the account until
        they are used or a period of 12 months has elapsed without a purchase on
        the account.
      </Text>
      <Spacer space="x9" />
      <Spacer space="x2" />
    </Div>
  )
}

export default SupplementalInfo
